import type { UserSubscription } from "@/feature-wallet/models/user-subscriptions.mjs";
import { proxy } from "@/util/proxy.mjs";

/**
 * A stub subscription is a simplified version of a premium subscription that is used to
 * represent subscriptions that are not initiated through the typical premium subscription
 * implementation (i.e. crypto).
 *
 * This should be the minimum amount of information needed to represent a premium subscription,
 * and should not generally be imported directly. If you're creating a utility that will
 * potentially interact with it, it would be highly preferable to `Pick<Subscription, ...>` the
 * necessary fields.
 */
export type StubSubscription = Unwrap<
  Pick<
    UserSubscription,
    "createdAt" | "willCancelAtPeriodEnd" | "currentPeriodEnd"
  > & {
    status: "active";
    coupon?: UserSubscription["coupon"];
  }
>;

interface SubscriptionRefs {
  /// Used to override the typical premium subscription implementation (i.e. crypto).
  activeSubscription: StubSubscription | null;
}

export const subscriptionRefs = proxy<SubscriptionRefs>({
  activeSubscription: null,
});
